import OpenIcon from "<ebay-chevron-down-icon>";
import CloseIcon from "<ebay-chevron-up-icon>";
$ {
    const displayValue = input.isStringValue ? input.module : JSON.stringify(input.module, null, 4);
}
<section class=`str-debug ${state.active ? "active" : ""}`>
    <if(!input.__empty)>
        <${input.renderBody} />
    </if>
    <else>
        <section class="str-debug__empty-component">
            <if(input.module._uxComponent)>No component found (${input.module._uxComponent})</if>
            <else>Module is not mapped to a component</else>
        </section>
    </else>
    <button
        class=`str-debug__toggle-button ${input.inlineButton && "str-debug__toggle-button--inline"}`
        on-click("toggleInputDisplay")
        title="Toggle module input display"
    >
        <${state.active ? CloseIcon : OpenIcon} />
        ${input["full-view"]}
    </button>
    <article class=`${state.active ? "active" : ""} ${input.view === "full" ? "full-view" : ""}`>
        <textarea value=displayValue readonly></textarea>
    </article>
</section>
